/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

// @mui material components
import "rc-tree/assets/index.css";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { find } from "lodash";
import moment from "moment";
import MDTypography from "components/MDTypography";
import InputFileUpload from "../data/InputFile";

function FormCargarDocumento({ props, onChangeDoc }) {
  const { tituloDoc, documento, observacionesDoc } = props;

  return (
    <>
      <TextField
        value={tituloDoc}
        onChange={(event) => {
          onChangeDoc(event.target.value, "tituloDoc");
        }}
        error={false}
        helperText={""}
        label={"Titulo del documento"}
        onBlur={() => {}}
        style={{ width: "100%", marginBottom: "1.5rem", cursor: "pointer" }}
        variant="outlined"
        fullWidth
        size="small"
        autoComplete="off"
        InputLabelProps={{ shrink: true }}
      />
      <MDTypography variant="h5" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
        Archivo
      </MDTypography>
      <InputFileUpload
        onchangeFile={(documento) => {
          onChangeDoc(documento, "documento");
        }}
        valueF={documento}
      />
      <TextField
        value={observacionesDoc}
        onChange={(event) => {
          onChangeDoc(event.target.value, "observaciones");
        }}
        label={"Observaciones"}
        variant="outlined"
        style={{ width: "100%", marginBottom: "1.5rem", marginTop: "1.5rem" }}
        multiline
        rows={4}
        size="small"
        autoComplete="off"
        InputLabelProps={{ shrink: true }}
      />
    </>
  );
}

export default FormCargarDocumento;
